import { GetInlineHelpContentInput, GetInlineHelpContentOutput } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { Observable } from 'rxjs';
import CarrierLogisticsWebServerClient from '../clients/CarrierLogisticsWebServerClient';

interface InlineHelpInput {
  pageId: string;
}

export function getInlineHelpContentService({
  pageId
}: InlineHelpInput
): Observable<GetInlineHelpContentOutput> {
  return CarrierLogisticsWebServerClient.getInlineHelpContent(GetInlineHelpContentInput.clone({
    pageId
  }));
}

export default getInlineHelpContentService;
